import 'slick-carousel'
import arrow from '../../images/arrow.svg'

export default function studyItemCarousel() {
  if ($('.slk-study-item-slider').length > 0) {
    var w = $( window ).width();
    var width = w < 577 ? 'width="32"' : '';
    $('.slk-study-item-slider').not('.slick-initialized').slick({
      // lazyLoad: 'ondemand',
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><img src="/wp-content/themes/buy2themeforest-child/dist/${arrow}" ${width}></button>`,
      nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button"><img src="/wp-content/themes/buy2themeforest-child/dist/${arrow}" ${width}></button>`,
      responsive: [
        {
          breakpoint: 1245,
          settings: {
            slidesToShow: 3,
            dots: false,
            arrows: true,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            dots: false,
            arrows: true,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            dots: false,
            arrows: true,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            dots: false,
            arrows: true,
          }
        }
      ]
    });
  }
}
